import { render, staticRenderFns } from "./ChangeLogParts.vue?vue&type=template&id=ba6e9c9c"
import script from "./ChangeLogParts.vue?vue&type=script&lang=js"
export * from "./ChangeLogParts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports